import { Language } from '@shared/types'
import { Translations } from '@ui-common/types'

import messagesFi from './fi.json'
import messagesSv from './sv.json'

export const messages: Translations = {
  [Language.Fi]: messagesFi,
  [Language.Sv]: messagesSv,
}
